import { TrashIcon } from '@heroicons/react/24/outline';

interface FilterTextFieldProps {
  value?: string;
  setValue: (value: string) => void;
  placeholder: string;
  showClear?: boolean;
  disabled?: boolean;
}

export const FilterTextField: React.FC<FilterTextFieldProps> = ({
  value = '',
  setValue,
  placeholder,
  showClear = false,
  disabled = false,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setValue(value);
    }
  };

  return (
    <>
      <input
        type="text"
        placeholder={placeholder}
        className="w-full border-0 bg-transparent focus:ring-0 disabled:bg-gray-100"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        disabled={disabled}
      />
      {showClear && value && (
        <button
          className="flex items-center justify-end self-stretch justify-self-stretch rounded-r-md px-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-100"
          onClick={() => {
            setValue('');
          }}
        >
          <TrashIcon className="h-4 w-4" />
        </button>
      )}
    </>
  );
};
